export default __webpack_public_path__ + "images/56b29ad1b1b5665d22c7b2af27453eaa.png";